import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { get_prework_attempt } from '../services/api';
import { rootRoute } from "../../../config";
import { errorMsg } from "../../../helper/helpers";
import { motion } from "framer-motion";
import prevArrow from "../assets/prevArrow.png";
import leftArrow from "../assets/leftArrow.png";
import rightArrow from "../assets/rightArrow.png";
import clock from "../assets/clock.png";
import target from "../assets/target.png";
import profitreport from "../assets/profitreport.png";
import trophy from "../assets/trophy.png";
import ScmModuleStyle from '../styles/scm.module.css';
import Prework from "./Prework";

const PreworkDecisionHistory = () => {
   const location = useLocation();
   const navigate = useNavigate();
   const queryParams = new URLSearchParams(location.search);
   const [listOfUsers, setListOfUsers] = useState([]);
   const [simulationDetailSummary, setSimulationDetailSummary] = useState([]);
   const [decisionhistory, setDecisionhistory] = useState([]);
   const [attempt, setAttempt] = useState(queryParams.get("attempt"));
   const [pagination, setPagination] = useState({ "prev": false, "next": false });
   const [executioninstanceid, setExecutioninstanceid] = useState("");
   const [decisionPageHeight, setDecisionPageHeight] = useState("");
   const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError] = useOutletContext();

   let session_id = queryParams.get("sid");
   let resource_id = queryParams.get("resid");
   let course_id = queryParams.get("cid");
   let user_id = queryParams.get("userid");

   let attempt_id = queryParams.get("attempt");
   let role = queryParams.get("from")=="studRev" ? "student" : "instructor";

   const checkNum = (num, factor) => {
      return num < 0
         ? `-$${Math?.abs(num)?.toLocaleString(undefined, {
            minimumFractionDigits: factor,
            maximumFractionDigits: factor,
         })}`
         : `$${num?.toLocaleString(undefined, {
            minimumFractionDigits: factor,
            maximumFractionDigits: factor,
         })}`;
   };
   const initDecisionHistory = () => {
      (simObj?.status != 'COMPLETED' && (attempt == undefined && user_id == undefined)) && navigate(`${rootRoute}/im/simulation`);
      window.$("html, body").animate({ scrollTop: 0, }, 100);
      setIsLoader(true);
   };
   const backToSimulationList = () => {
      setIsLoader(true);
      if(role == "student"){
         navigate(rootRoute + `/scm/preworkstudentreview?${queryParams}`);
      }else{
        navigate(rootRoute + `/scm/preworkinstructorreview?${queryParams}`);
      }
   }
   const getNextAttempt = () =>{  
      setIsLoader(true);
      let index = simulationDetailSummary?.findIndex((sdObj)=> sdObj.attemptno == attempt);
      let currSdSObj = simulationDetailSummary[index + 1];
      if(currSdSObj != undefined){
        setAttempt(currSdSObj.attemptno);
        queryParams.set("attempt",currSdSObj.attemptno);
        setExecutioninstanceid(currSdSObj?.executioninstanceid);
        (simulationDetailSummary[index + 2] != undefined) ? setPagination({"prev":true,"next":false}) : setPagination({"prev":false,"next":true});
      }else{
        setPagination({"prev":false,"next":true});
        setIsLoader(false);
      }
    }
    const getPrevAttempt = () =>{ 
      setIsLoader(true);
      let index = simulationDetailSummary?.findIndex((sdObj)=> sdObj.attemptno == attempt);
      let currSdSObj = simulationDetailSummary[index - 1];
      if(currSdSObj != undefined){
        setAttempt(currSdSObj.attemptno);
        queryParams.set("attempt",currSdSObj.attemptno);
        setExecutioninstanceid(currSdSObj?.executioninstanceid);
        (simulationDetailSummary[index - 2] != undefined) ? setPagination({"prev":false,"next":false}) : setPagination({"prev":true,"next":false});
      }else{
        setPagination({"prev":true,"next":false});
        setIsLoader(false);
      }
    }
    const OnLoadPagination = () =>{  
        let lastObjIndex = simulationDetailSummary?.length -1;
        let firstObjIndex = 0;
        let currentIndex = simulationDetailSummary?.findIndex((sdObj)=> sdObj.attemptno == attempt);
        (currentIndex == lastObjIndex) && setPagination({"prev":false,"next":true});
        (currentIndex == firstObjIndex) && setPagination({"prev":true,"next":false});
        if((currentIndex != lastObjIndex) && (currentIndex != firstObjIndex)){
          setPagination({"prev":false,"next":false});
        }
    }
   const getSimulationDetailSummary = () => {
      setSimulationDetailSummary((attempt != undefined && user_id != undefined) ? simObj?.simulationdetails : []);
    //   setIsLoader(false);
   };
   const updateExcutionInstanceId = () => {
      if (attempt != undefined && user_id != undefined) {
         setExecutioninstanceid(simulationDetailSummary?.filter((sdObj) => sdObj.attemptno == attempt)[0]?.executioninstanceid)
      } else {
         setExecutioninstanceid(simObj?.executioninstanceid)
      }
   }
   const getDecisionHistory = () => {
      // debugger;
      (user_id != undefined) && get_prework_attempt(user_id, attempt).then(
         (response) => {
            if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
               setError(response?.data)
           }
           else{
            setDecisionhistory(response?.data);
            OnLoadPagination();
            setIsLoader(false);
            setIsOverlay(false)
           };
         }
      ).catch((error)=>{
         // setError(errorMsg);
         setError({"id":"00000","msg":errorMsg})
         console.log(error);
      })
   };

   useEffect(() => { 
      updateExcutionInstanceId(); 
      OnLoadPagination();
      console.log(simulationDetailSummary)
   }, [simulationDetailSummary])
   useEffect(() => { 
      getSimulationDetailSummary();
      if(document.querySelector(`.${ScmModuleStyle['decision-table']}`) != null ){
         document.querySelector(`.${ScmModuleStyle['decision-table']}`).scrollTop = 0;
      };
      console.log(attempt)
    }, [attempt])
   useEffect(() => { getDecisionHistory(); }, [attempt])
   useEffect(() => {
      if(document.querySelector("header.header") != null){
         document.querySelector("header.header").style.display = "none";
      }
      if(document.querySelector(`.${ScmModuleStyle['decisionhistory-container']} header.header h1`) != null){
         document.querySelector(`.${ScmModuleStyle['decisionhistory-container']} header.header h1`).tabIndex = -1;
      }
    //   const decisionHistoryPageHeight = window.innerHeight - document.getElementsByClassName(`${ScmModuleStyle.header}`)[0].clientHeight - document.getElementsByClassName(`${ScmModuleStyle.header2}`)[0].clientHeight - document.getElementsByClassName(`ui grid ${ScmModuleStyle.ui} ${ScmModuleStyle.grid}`)[0].clientHeight - document.querySelector(`.footer`).clientHeight - 20;
    //   setDecisionPageHeight(decisionHistoryPageHeight);
      document.querySelector(".App .row").style.minHeight = "auto";
      initDecisionHistory();
      setAttempt(queryParams.get("attempt"));
      // if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
      //    document.querySelector("footer.footer .footer-nav .footer-links").style.display = "none";
      // }
      // if (document.querySelector("footer.footer .container") != null) {
      //    document.querySelector("footer.footer .container").style.justifyContent = "center";
      //  }
      if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
         document.querySelector("footer.footer .footer-nav .footer-links").firstChild.style.display = "none";
      }
    document.title = "Supply Chain Management Prework | Decision History";
      return () => {
         document.querySelector(".App .row").style.minHeight = "100vh";
         if (document.querySelector(`.${ScmModuleStyle['decisionhistory-container']} header.header`) != undefined) {
            document.querySelector(`.${ScmModuleStyle['decisionhistory-container']} header.header`).style.display = "block";
         }
         if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
            document.querySelector("footer.footer .footer-nav .footer-links").style.display = "block";
         }
         if (document.querySelector("footer.footer .container") != null) {
            document.querySelector("footer.footer .container").style.justifyContent = "space-between";
          }
      };
   }, []);

   return (
      <motion.div className={`${ScmModuleStyle['prework-decisionhistory']} ${ScmModuleStyle['decisionhistory-container']}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
         <header className={`header ${ScmModuleStyle.header}`}>
            <div className={`container ${ScmModuleStyle.container}`}>
               <div className={`${ScmModuleStyle['icon-header-box']}`}>
                  {
                     (attempt != undefined && user_id != undefined) && <button onClick={backToSimulationList}><img src={prevArrow} /></button>
                  }
               </div>
               <h1>Decision History</h1>
            </div>
         </header>
         <div className={`${ScmModuleStyle['decisionhistory-wrapper']}`}>
            <div className={`${ScmModuleStyle.header2}`}>
               <h3>
                  {attempt != undefined && `Supply Chain Management Prework (Attempt ${attempt})`}
               </h3>

               <div>
                  {
                     (attempt != undefined && user_id != undefined && simulationDetailSummary?.length != 1) && <div className={`${ScmModuleStyle['pagination-icons']}`}>
                        <button disabled={attempt == 1} onClick={getPrevAttempt}><img src={leftArrow} /></button>
                        <button disabled={attempt == simulationDetailSummary?.length} onClick={getNextAttempt}><img src={rightArrow} /></button>
                     </div>
                  }
               </div>
            </div>
            <Prework from="preworkdecisionhistory" data={decisionhistory}/>
         </div>
      </motion.div>
   );

};

export default PreworkDecisionHistory